import axios from 'axios';

const xApiKey = process.env.REACT_APP_PERSAL_X_API_KEY;
const internalURL = process.env.REACT_APP_INTERNAL_PERSAL_BASE_URL;

class PersalProvider {

  static async create(data) {
    let payload = {
      userId: data.userId,
      surname: data.surname,
      emailAddress: data.email,
      firstName: data.firstName,
      identityNumber: data.idNumber,
      institutionCode: data.institutionCode,
    }

    try {
      let res = await axios.post(internalURL + 'create_intermediary', payload, { headers: { 'x-api-key': xApiKey } });
      return { data: res };
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.data;
      } else {
        console.error("Unexpected error:", error);
        return "An unexpected error occurred.";
      }
    }
  }

  static async update(data) {

    try {
      let res = await axios.put(internalURL + 'update_intermediary', {
        surname: data.surname,
        emailAddress: data.email,
        firstName: data.firstName,
        identityNumber: data.idNumber,
        institutionCode: data.institutionCode,
      }, { headers: { 'x-api-key': xApiKey } });
      return { data: res };
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.data;
      } else {
        console.error("Unexpected error:", error);
        return "An unexpected error occurred.";
      }
    }
  }

  static async delete(data) {
    try {

      let res = await axios.delete(internalURL + 'delete_intermediary', {
        headers: { 'x-api-key': xApiKey },
        data: {
          identityNumber: data.idNumber,
          reasonCode: data.reasonCode,
          institutionCode: data.institutionCode,
        }
      });

      return { data: res };
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.data;
      } else {
        console.error("Unexpected error:", error);
        return "An unexpected error occurred.";
      }
    }
  }

  static async retrieveUser(search) {
    try {
      const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(search);
      const queryParams = isEmail
        ? { emailAddress: search }
        : { userCode: search };

      let res = await axios.get(internalURL + 'get_user', {
        params: queryParams,
        headers: { 'x-api-key': xApiKey }
      });

      return { data: res };
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data;
      } else {
        return "An unexpected error occurred.";
      }
    }
  }

  static async retrievePerIntermediaryId(search) {
    try {
      let res = await axios.get(internalURL + `get_intermediary_user?userId=${search}`, { headers: { 'x-api-key': xApiKey } });
      return { data: res };
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.data;
      } else {
        console.error("Unexpected error:", error);
        return "An unexpected error occurred.";
      }
    }
  }

  static async retrieveInstitutionCampaigns(search) {
    try {
      let res = await axios.get(internalURL + `get_institution_campaigns?institutionCode=${search}`, { headers: { 'x-api-key': xApiKey } });
      return {
        data: res
      };
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.data;
      } else {
        console.error("Unexpected error:", error);
        return "An unexpected error occurred.";
      }
    }
  }

  static async retrieveInstitutionCodes() {
    try {
      let res = await axios.get(internalURL + `get_institution_codes`, { headers: { 'x-api-key': xApiKey } });
      return { data: res };
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.data;
      } else {
        console.error("Unexpected error:", error);
        return "An unexpected error occurred.";
      }
    }
  }

}

export default PersalProvider;